import * as React from "react";

function MailIcon2(props) {
  return (
    <svg viewBox="0 0 17.059 12.844" {...props}>
      <g fill="#fff" stroke="#333" data-name="Layer 2">
        <path strokeMiterlimit={10} d="M.5.5h16.059v11.844H.5z" />
        <path
          strokeLinejoin="round"
          d="M8.529 7.344L.5.5h16.059l-8.03 6.844z"
        />
      </g>
    </svg>
  );
}

const MemoMailIcon2 = React.memo(MailIcon2);
export default MemoMailIcon2;
